import { useState, useEffect } from "react";

import { apiRoot } from "../constants";

export const useCuisines = () => {
  const [cuisines, setCuisines] = useState([{title: 'a'}]);
  const [error, setError] = useState(false);

  useEffect(() => {
    const headers = {
      "Content-Type": "application/json",
    };
    fetch(`${apiRoot}/cuisines`, {
      headers
    })
      .then((resp) => {
        if (resp.status === 200) {
          resp.json().then((json) => {
            setCuisines(json.cuisines);
            setError(false);
          });
        } else {
          setError(true);
          setCuisines([]);
        }
      })
      .catch((err) => {
        setError(true);
        setCuisines([]);
      });
  }, []);

  return {
    cuisines,
    error,
  };
};

